import * as React from "react"

const MOBILE_BREAKPOINT = 1024

const getIsMobileSnapshot = () =>
  window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches

const getIsMobileServerSnapshot = () => false

const subscribeToMobileBreakpoint = (onStoreChange: () => void) => {
  const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  mediaQuery.addEventListener("change", onStoreChange)
  return () => mediaQuery.removeEventListener("change", onStoreChange)
}

export function useIsMobile() {
  return React.useSyncExternalStore(
    subscribeToMobileBreakpoint,
    getIsMobileSnapshot,
    getIsMobileServerSnapshot,
  )
}
